import React from "react";

/**
 * WidgetRegistry - Maps widget_types.typeKey to adapter components (lazy import).
 * Follows the same factory pattern as ContentRenderer.js
 */
const adapterMap = {
  // Tables
  data_table_rdt: React.lazy(() => import("./adapters/ReactDataTableAdapter")),
  data_table_prime: React.lazy(() => import("./adapters/PrimeReactTableAdapter")),

  // Charts
  chart_bar: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_line: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_pie: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_doughnut: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_funnel: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_gauge: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_solidgauge: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_stackedbar: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_groupedbar: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_variablepie: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_bartarget: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_multibartarget: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_area: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_scatter: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_heatmap: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_treemap: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_sunburst: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_sankey: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_dependencywheel: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_networkgraph: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_organization: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_timeline: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_xrange: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_histogram: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_pareto: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_bullet: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_venn: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_wordcloud: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_streamgraph: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_tilemap: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_item: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_dumbbell: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_lollipop: React.lazy(() => import("./adapters/HighchartsAdapter")),
  chart_variwide: React.lazy(() => import("./adapters/HighchartsAdapter")),

  // KPI
  kpi_card: React.lazy(() => import("./adapters/KPICardAdapter")),

  // Forms
  search_filter: React.lazy(() => import("./adapters/SearchFilterAdapter")),
  dynamic_form: React.lazy(() => import("./adapters/DynamicFormAdapter")),

  // Media
  static_html: React.lazy(() => import("./adapters/StaticHtmlAdapter")),
};

/**
 * Get the adapter component for a given typeKey
 * @param {string} typeKey - The widget type key from widget_types table
 * @returns {React.LazyExoticComponent|null} The lazy-loaded adapter component
 */
export function getAdapter(typeKey) {
  return adapterMap[typeKey] || null;
}

/**
 * Check if an adapter exists for a given typeKey
 * @param {string} typeKey
 * @returns {boolean}
 */
export function hasAdapter(typeKey) {
  return typeKey in adapterMap;
}

/**
 * Get all registered type keys
 * @returns {string[]}
 */
export function getRegisteredTypes() {
  return Object.keys(adapterMap);
}

export default adapterMap;
